import React, { useState } from 'react';
import cn from 'classnames';
import PropTypes, { array } from 'prop-types';
import { useTranslation } from 'react-i18next';

import {
  EmptyState,
  Loading,
  Table
} from 'components/common/Elements/Elements';
import { cohortArrTableConf } from '../helpers/configurates';
import { moneyFormater, textToDateMY } from 'utils/common';
import { cohortCount, percentToColor } from 'utils/cohorts';

import classes from './CohortTable.module.scss';

const CohortTable = ({ tableData = [], loader, unit }) => {
  const { t } = useTranslation(['activity']);
  const [row, setRow] = useState('');

  const mouseEnter = e => {
    setRow(e.currentTarget.getAttribute('r'));
  };
  const mouseLeave = () => {
    setRow('');
  };

  const cell = (cellData, ind) => {
    if (ind === 0) {
      return (
        <Table.Cell
          key={`cell-${ind}-${cellData}`}
          className={classes.cell}
          onMouseEnter={mouseEnter}
          r={`r${ind}`}
        >
          {textToDateMY(cellData)}
        </Table.Cell>
      );
    }

    if (ind > 2) {
      return (
        <Table.Cell
          key={`cell-${ind}-${cellData}`}
          className={cn(
            classes.cell,
            percentToColor(cellData['arrPercent'], classes),
            row === `r${ind}` && classes.hov
          )}
          onMouseEnter={mouseEnter}
          r={`r${ind}`}
          classNameContent={classes.center}
        >
          {unit === t('activity:units.PERCENT')
            ? `${cellData['arrPercent']}${t('activity:units.PERCENT')}`
            : moneyFormater(cellData['totalArr'])}
        </Table.Cell>
      );
    }

    return (
      <Table.Cell
        key={`cell-${ind}-${cellData}`}
        className={classes.cell}
        onMouseEnter={mouseEnter}
        r={`r${ind}`}
        classNameContent={classes.center}
      >
        {cellData}
      </Table.Cell>
    );
  };

  const lastRow = (cellData, ind, length) => {
    if (ind === 0) {
      return (
        <Table.Cell key={cellData} className={classes.cell}>
          {cellData}
        </Table.Cell>
      );
    }

    return (
      <Table.Cell
        key={`cell-${ind}-${cellData}`}
        className={classes.cell}
        classNameContent={classes.center}
      >
        {Math.round(cellData / length - 1)}
      </Table.Cell>
    );
  };

  return (
    <div className={classes.outer}>
      <div className={classes.inner}>
        <Table className={classes.table}>
          <Table.Header>
            <Table.Row withBorder={false}>
              {cohortArrTableConf.map(({ field, title }, ind) => (
                <Table.HeaderCell
                  key={field}
                  className={classes.header}
                  onMouseEnter={mouseEnter}
                  onMouseLeave={mouseLeave}
                  r={`r${ind}`}
                  title={title}
                  classNameTitle={classes.header_fixed}
                />
              ))}
              {cohortCount.map(({ title }, ind) => (
                <Table.HeaderCell
                  key={title}
                  className={cn(
                    classes.header,
                    unit !== t('activity:units.PERCENT')
                      ? classes.header_dollar
                      : ''
                  )}
                  onMouseEnter={mouseEnter}
                  onMouseLeave={mouseLeave}
                  r={`r${ind}`}
                  title={title}
                  classNameTitle={classes.header_fixed}
                />
              ))}
            </Table.Row>
          </Table.Header>
          {loader || tableData.length === 0 ? (
            <Table.Body></Table.Body>
          ) : (
            <Table.Body>
              {tableData.map((rowData, rowInd) =>
                rowInd !== tableData.length - 1 ? (
                  <Table.Row key={rowData[0]} className={classes.row}>
                    {rowData.map((cellData, ind) => cell(cellData, ind))}
                  </Table.Row>
                ) : (
                  <Table.Row key={rowData[0]} className={classes.row}>
                    {rowData.map((cellData, ind) =>
                      lastRow(cellData, ind, tableData.length)
                    )}
                  </Table.Row>
                )
              )}
            </Table.Body>
          )}
        </Table>
      </div>
      {tableData.length === 0 && <EmptyState />}
      {loader && <Loading />}
    </div>
  );
};

CohortTable.propTypes = {
  tableData: PropTypes.arrayOf(array),
  loader: PropTypes.bool,
  unit: PropTypes.string
};

export default CohortTable;
